import React from 'react';

import { Stack } from '@mui/material';
import { Label } from '@common/Label';
import { Expression } from '@common/Expression';
import { TelnyxPricingCalculatorMetadata } from '../../../tool.types';
import { TTCountryCode, TTProduct } from '@common/Node/NodeSidebar/Extensions/PricingCalculator';

interface Props {
  metadata: TelnyxPricingCalculatorMetadata;
  setToolMetadata: React.Dispatch<React.SetStateAction<TelnyxPricingCalculatorMetadata>>;
  toolArgumentOptions: object;
}

export const TelnyxPricingExecution: React.FC<Props> = ({ metadata, setToolMetadata, toolArgumentOptions }) => {
  const updateTextField = (paramName: 'product' | 'countryCode', value: string) => {
    setToolMetadata((prevState) => ({ ...prevState, [paramName]: value }));
  };

  return (
    <Stack spacing={2}>
      <Stack spacing={1}>
        <Label title='Product' tooltip={TTProduct} />
        <Expression
          key={`product`}
          keyProp={`product`}
          value={metadata.product}
          title={'Product'}
          description={TTProduct}
          setValue={(newValue: string) => updateTextField('product', newValue)}
          options={toolArgumentOptions}
          placeholder='sms | mms | sip | voice | numbers | storage | iot | edge | verify | fax | video | networking | numberLookup | inference'
        />
      </Stack>
      <Stack spacing={1}>
        <Label title='Country Code' tooltip={TTCountryCode} />
        <Expression
          key={`countryCode`}
          keyProp={`countryCode`}
          value={metadata.countryCode}
          title={'countryCode'}
          description={TTCountryCode}
          setValue={(newValue: string) => updateTextField('countryCode', newValue)}
          options={toolArgumentOptions}
          placeholder='A country code in ALPHA-2 format, e.g. IE for Ireland.'
        />
      </Stack>
    </Stack>
  );
};
